export default "__VITE_ASSET__Cl8Ic7JR__"